import * as types from './types'

export default {
  [types.SET_LOADING](state, data) {
    state.isLoading = data
  },
  [types.SET_RELOAD](state, data) {
    state.isReloading = data
  },
}
